import React, { useState, useEffect } from "react"

import BreadCrumb from "../Components/BreadCrumb"
import { Button, Card, CardBody, CardTitle, FormGroup, Input, Label, Form, FormFeedback } from "reactstrap"
import ConnectWallet from "../Components/ConnectWallet"
import { useContracts, useWallet } from "../libs/useMetaMaskWallet"
import { connect } from "react-redux"
import SpinnerWrap from "../Components/SpinnerWrap"
import { useToast } from "../hooks/toast"

const Course = () => {
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [showSpinner, setShowSpinner] = useState(false)
    const [userHasAccess, setUserHasAccess] = useState(false)
    const [approvalPending, setApprovalPending] = useState(true)
    const [processingApprove, setProcessingApprove] = useState(false)

    const toast = useToast()
    const wallet = useWallet()
    const contract = useContracts()

    const chainId = 250 // FTM
    const amount = 2500
    const symbol = "CRED"

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === 250
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(() => {
        if (updateConnection() && wallet.account) {
            contract.courseContract.hasPurchased().then((res) => {
                setUserHasAccess(res)
            })
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }, [wallet.account, wallet.status, wallet.chainId])

    const approveFunction = () => {
        setProcessingApprove(true)
        contract.courseContract
            .approve(amount)
            .then(() => {
                setApprovalPending(false)
                setProcessingApprove(false)
                toast.addSuccess(`${amount} ${symbol} is approved successfully.`)
            })
            .catch(() => {
                setProcessingApprove(false)
                toast.addError("Approve Fail")
            })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        setShowSpinner(true)
        contract.courseContract
            .payProduct("influencercourse")
            .then(() => {
                setUserHasAccess(true)
                setShowSpinner(false)
            })
            .catch(() => {
                setShowSpinner(false)
            })
    }

    return (
        <React.Fragment>
            <div className="content course-page">
                <BreadCrumb items={["Course"]} />
                {!isLoading && (
                    <Card>
                        <CardBody>
                            {!isConnectedToWallet ? (
                                <ConnectWallet
                                    wallet={wallet}
                                    onChange={() => setIsConnectedToWallet(wallet.status === "connected")}
                                    chainId={chainId}
                                />
                            ) : userHasAccess ? (
                                <>
                                    <div className="row">
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                        <div className="col-4">
                                            <iframe
                                                src="https://player.vimeo.com/video/693723661?h=87d3d97677&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                                                frameborder="0"
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowfullscreen
                                                style={{ width: "100%", height: "300px" }}
                                                title="influencercourse1"
                                            ></iframe>
                                        </div>
                                    </div>
                                    <script src="https://player.vimeo.com/api/player.js"></script>
                                </>
                            ) : (
                                <div className="row">
                                    <div className="col-md-12 col-lg-8">
                                        <Form onSubmit={handleSubmit}>
                                            <FormGroup className="mb-3">
                                                <Label htmlFor="amount" className="form-label">
                                                    <CardTitle className="h3 label">Amount to be paid</CardTitle>
                                                </Label>
                                                <Input
                                                    type="text"
                                                    className="form-control"
                                                    id="amount"
                                                    placeholder="Enter the Amount"
                                                    name="amount"
                                                    value={`2500 ${symbol}`}
                                                    disabled={true}
                                                />
                                                <FormFeedback>The {symbol} required to apply for course!</FormFeedback>
                                            </FormGroup>
                                            <Button
                                                color="primary"
                                                className="waves-effect w-lg"
                                                style={{ width: "100%", marginRight: "10px" }}
                                                onClick={approveFunction}
                                                disabled={processingApprove || !approvalPending}
                                            >
                                                {approvalPending ? (
                                                    <SpinnerWrap
                                                        showSpinner={processingApprove}
                                                        txtTrue={"Processing..."}
                                                        txtFalse={`Approve ${symbol}`}
                                                    />
                                                ) : (
                                                    "Approved"
                                                )}
                                            </Button>
                                            <Button
                                                color="primary"
                                                className="waves-effect w-lg"
                                                style={{ width: "100%" }}
                                                disabled={showSpinner || approvalPending}
                                            >
                                                <SpinnerWrap showSpinner={showSpinner} txtTrue={"PAYMENT IN PROGRESS"} txtFalse={"PAY"} />
                                            </Button>
                                        </Form>
                                    </div>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                )}
            </div>
        </React.Fragment>
    )
}

const mapStateToProps = (state) => ({
    pointBalance: state.commonReducer.pointBalance
})

export default connect(mapStateToProps)(Course)
